import axios from 'axios';
import { generateJWT } from '@/utils';
import { useCookie } from '@/utils/composables/useCookie';
const apiUrl = import.meta.env.VITE_API_URL;
const vtoken = import.meta.env.VITE_TOKEN;
const vuser = import.meta.env.VITE_USER;

const redirectTo = (url) => {
  if(window.location.href === url) return;
	window.location.href = url;
};

function httpService() {
	const service = axios.create();

	service.interceptors.request.use(
		function (config) {
			const mode = window.localStorage.getItem('mode');
			const token = useCookie(vtoken).value;
			const user = useCookie(vuser).value;
			const lang = window.localStorage.getItem('lang') || 'vi';
			// Do something before request is sent
			return {
				...config,
				baseURL: apiUrl,
				headers: token
					? {
							'X-W-Auth': generateJWT(
								// mode === 'nurse' ? user.email : user.phone,
								user.email,
								token
							),
							'X-Locale': lang,
					  }
					: {
							'X-Locale': lang,
					  },
			};
		},
		function (error) {
			// Do something with request error
			return Promise.reject(error);
		}
	);

	service.interceptors.response.use(handleSuccess, handleError);

	function handleSuccess(response) {
		return response;
	}

	function handleError(error) {
		switch (error.response?.status) {
			case 400:
				console.log('Bad Request');
				break;
			case 401:
				console.log('Token expired / Unauthorized');

				const mode = window.localStorage.getItem('mode');
				const modePath = mode === 'nurse' ? 'cong-tac-vien' : '';
        useCookie(vtoken).value = null
        useCookie(vuser).value = null

				setTimeout(() => {
					redirectTo(`${window.location.origin}${!modePath ? '':`/${modePath}`}/dang-nhap`);
				}, 1000);

				break;
			case 403:
				console.log('Resource is not found!');
				break;
			case 404:
				console.log('Not found');
				break;
			default:
				console.log('Internal server error');
				break;
		}

		// FIXME: custom error 500
		const res =
			error.response?.status === 500
				? {
						data: {
							error: 'Internal server error',
							data: { code: 'Internal server error' },
						},
				  }
				: error.response;
		return res;
	}

	return {
		get: (...args) => service.get(...args),
		post: (...args) => service.post(...args),
		put: (...args) => service.put(...args),
		patch: (...args) => service.patch(...args),
		delete: (...args) => service.delete(...args),
	};
}

export default httpService();
